export default "__VITE_ASSET__9a92158e__"